// @flow

import * as React from 'react';
import type { CollectionView } from 'wijmo/wijmo';
import { Route } from 'react-router-dom';

import Header from './Header';
import { OrderContentConsumer } from '../context/orderContent.context';
import { getModuleNameFromLocation } from '../utils';

export default class HeaderContainer extends React.Component<{}> {
  items: CollectionView;

  render() {
    return (
      <OrderContentConsumer>
        {({
          orderItems,
          selectedOrderType,
          hasUnsavedOrderType,
          isLoading,
        }: any) => {
          return (
            <Route
              path="/"
              children={({ match, location }) => {
                const moduleName = getModuleNameFromLocation(location);
                return (
                  <Header
                    selectedOrderType={selectedOrderType}
                    hasUnsavedOrderType={hasUnsavedOrderType}
                    items={
                      orderItems &&
                      orderItems.totalItemCount > 0 &&
                      orderItems.items.filter(
                        i => i.maxItemQty.ActionPerOrderType !== 'remove',
                      )
                    }
                    isLoading={isLoading}
                    moduleName={moduleName}
                  />
                );
              }}
            />
          );
        }}
      </OrderContentConsumer>
    );
  }
}
